import axios from "axios";

// Configuración básica de Axios
const api = axios.create({
    baseURL: "http://ocsinventory.siatigroup.com/ocsapi/v1", // Cambia a la URL base del OCS Inventory
    headers: {
        "Content-Type": "application/json",
    },
    auth: {
        username: "ocsapi", // Usuario configurado en el archivo .htpasswd
        password: "S1ati2024.", // Contraseña configurada en el archivo .htpasswd
    },
});

export default api;


